import { useEffect } from 'react';
import { useApp, type ScreenId } from '../state/store';

/**
 * Kopplar Zustand-`screen` till browserns history, så bakåt-knappen fungerar
 * (matchar prototypens `history.pushState` / popstate-mönster).
 */
export function useHistoryNavigation() {
  const screen = useApp((s) => s.screen);
  const setScreen = useApp((s) => s.setScreen);

  useEffect(() => {
    if (!history.state || history.state.screen !== screen) {
      history.pushState({ screen }, '');
    }
  }, [screen]);

  useEffect(() => {
    const onPop = (e: PopStateEvent) => {
      const next = (e.state?.screen as ScreenId | undefined) ?? 1;
      setScreen(next);
    };
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, [setScreen]);
}
